import { gql } from '@generated/gql';

export const appointment = gql(`
  query Appointment($id: ID!) {
    appointment(id: $id) {
      id
      basketId
      isEnded
      type
      path
      isProtectedPath
      isEnded
      participants {
        id
        partnerId
        name
        type
        canDiscussInsurance
      }
      controller {
        id
        name
        type
        canDiscussInsurance
      }
      connector {
        shortId
        id
      }
      referrer {
        customer {
          accountNumber
        }

      }
    }
  }
`);

export const appointmentUpdated = gql(`
  subscription AppointmentUpdated($id: ID!) {
    appointmentUpdated(id: $id) {
      id
      basketId
      isEnded
      type
      path
      isProtectedPath
      participants {
        id
        partnerId
        name
        type
        canDiscussInsurance
      }
      controller {
        id
        name
        type
        canDiscussInsurance
      }
      connector {
        shortId
        id
      }
      referrer {
        customer {
          accountNumber
        }
      }
    }
  }
`);

export const joinRemoteAppointment = gql(`
  mutation JoinRemoteAppointment($id: ID!) {
    joinRemoteAppointment(id: $id) {
      me {
        id
        token
        type
      }
      appointment {
        id
        basketId
        isEnded
        type
        path
        isProtectedPath
        participants {
          id
          partnerId
          name
          type
        }
        controller {
          id
          name
          type
        }
      }
    }
  }
`);

export const supportRemoteAppointment = gql(`
  mutation SupportRemoteAppointment($id: ID!) {
    supportRemoteAppointment(id: $id) {
      me {
        id
        token
        type
      }
      appointment {
        id
        basketId
        isEnded
        type
        path
        isProtectedPath
        participants {
          id
          partnerId
          name
          type
        }
        controller {
          id
          name
          type
        }
      }
    }
  }
`);

export const requestControlRemoteAppointment = gql(`
  mutation RequestControlRemoteAppointment($id: ID!) {
    requestControlRemoteAppointment(id: $id)
  }
`);

export const giveControlRemoteAppointment = gql(`
  mutation GiveControlRemoteAppointment($id: ID!, $requestorId: ID!) {
    giveControlRemoteAppointment(id: $id, requestorId: $requestorId)
  }
`);

export const denyControlRemoteAppointment = gql(`
  mutation DenyControlRemoteAppointment($id: ID!, $requestorId: ID!) {
    denyControlRemoteAppointment(id: $id, requestorId: $requestorId)
  }
`);

export const addBasketIdToRemoteAppointment = gql(`
  mutation AddBasketIdToRemoteAppointment($id: ID!, $basketId: ID!) {
    addBasketIdToRemoteAppointment(id: $id, basketId: $basketId)
  }
`);

export const endRemoteAppointment = gql(`
  mutation EndRemoteAppointment($id: ID!) {
    endRemoteAppointment(id: $id)
  }
`);

export const appointmentEvent = gql(`
  subscription AppointmentEvent($id: ID!) {
    appointmentEvent(id: $id) {
      ... on ControlGivenEvent {
        isForced
        timestamp
        fromParticipant {
          ...Participant
        }
        toParticipant {
          ...Participant
        }
      }
      ... on ControlRequestedEvent {
        timestamp
        fromParticipant {
          ...Participant
        }
        toParticipant {
          ...Participant
        }
      }
      ... on ControlDeniedEvent {
        timestamp
        fromParticipant {
          ...Participant
        }
        toParticipant {
          ...Participant
        }
      }
      ... on ParticipantJoinedAppointmentEvent {
        timestamp
        participant {
          ...Participant
        }
        __typename
      }
      ... on ParticipantLeftAppointmentEvent {
        timestamp
        participant {
          ...Participant
        }
        reason
        __typename
      }
      ... on BasketUpdatedEvent {
        timestamp
        __typename
      }
      ... on HeartbeatEvent {
        timestamp
        participantId
        __typename
      }
      ... on StateChangedEvent {
        timestamp
        key
        data
        __typename
      }
    }
  }

  fragment Participant on AppointmentParticipant {
    id
    name
    type
    canDiscussInsurance
  }
`);

export const appointmentInteractionDialog = gql(`
  mutation AppointmentInteractionDialog($id: ID!, $dialog: ID!, $open: Boolean!, $isLoading: Boolean!, $variant: String) {
    appointmentInteractionDialog(id: $id, dialog: $dialog, open: $open, isLoading: $isLoading, variant: $variant)
  }
`);

export const notifyBasketUpdated = gql(`
  mutation NotifyBasketUpdated($id: ID!) {
    notifyBasketUpdated(id: $id)
  }
`);

export const appointmentAcknowledgeHeartbeat = gql(`
  mutation AppointmentAcknowledgeHeartbeat($id: ID!) {
    appointmentAcknowledgeHeartbeat(id: $id)
  }
`);

export const appointmentSyncState = gql(`
  mutation AppointmentSyncState($id: ID!, $key: ID!, $data: Map!) {
    appointmentSyncState(id: $id, key: $key, data: $data)
  }
`);

export const appointmentState = gql(`
  query AppointmentState($id: ID!, $key: ID!) {
    appointmentState(id: $id, key: $key)
  }
`);
